export default "__VITE_ASSET__D60XtsFF__"